import { useAuth, useOutletApi } from "@/features/authentication";
import { PermissionEnum } from "@/features/permissions";
import { usePendingCount } from "@/hooks";

// Dispatched on window once an incoming invoice has been turned into a purchase
// invoice, so the drawer badge drops without waiting for the next poll.
export const INCOMING_SALES_INVOICES_CHANGED_EVENT =
  "incoming-sales-invoices:changed";

/**
 * How many sales invoices from a hub are waiting for this outlet to raise the
 * matching purchase invoice. Buyer-scoped, so it follows the active outlet, and
 * the endpoint already excludes invoices that have one.
 */
export const useIncomingSalesInvoicesCount = () => {
  const { outlet, hasPermission } = useAuth();
  const api = useOutletApi();

  return usePendingCount({
    api,
    url: "sales-invoices/incoming",
    // Any outlet can be the buyer on an internal sale, so this is gated on
    // permission alone. READ_SALES_INVOICES is what the endpoint enforces.
    enabled:
      !!outlet?.id && hasPermission(PermissionEnum.READ_SALES_INVOICES),
    changedEvent: INCOMING_SALES_INVOICES_CHANGED_EVENT,
  });
};
